export const tierNumbers = {
  'Global': 1,
  'Challengers': 2,
  'Regionals': 3,
  'Game-Changers': 'GC'
}